import EditClient from './EditClient';
import {ActionCreators} from '../../actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getUser, getClient, getLocation} from '../../reducers/rootReducer';

const mapStateToProps = state => {
  const {user} = getUser(state);
  const {addingClient, addedClient, clients, client, loadedClients, loadingClients, updatingClient} = getClient(state);
  const {locations} = getLocation(state);

  return {
    user,
    addingClient,
    addedClient,
    clients,
    client,
    loadedClients,
    loadingClients,
    updatingClient,
    locations
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditClient);
